<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( aba == 'atendimento' || !aba ) ? 'active' : ''" @click.prevent="abrir('atendimento')">
                        Atendimento
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( aba == 'recebimento' ) ? 'active' : ''" @click.prevent="abrir('recebimento')">
                        Recebimento
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'movimentacao' ? 'active' : ''" @click.prevent="abrir('movimentacao')">
                        Movimentações
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'compra' ? 'active' : ''" @click.prevent="abrir('compra')">
                        Compra
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'saldos' ? 'active' : ''" @click.prevent="abrir('saldos')">
                        Saldos 
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral 
                    </a>
                </li>
                <li class="nav-item">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'gestaoestoque' ? 'active' : ''" @click.prevent="abrir('gestaoestoque')">
                                Gestão de Estoque 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'local' ? 'active' : ''" @click.prevent="abrir('local')">
                                Local de Armazenagem 
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" :class="aba == 'grupo' ? 'active' : ''" @click.prevent="abrir('grupo')">
                                Grupo 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'item' ? 'active' : ''" @click.prevent="abrir('item')">
                                Item de Estoque 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'kit' ? 'active' : ''" @click.prevent="abrir('kit')">
                                Kit 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'fornecedor' ? 'active' : ''" @click.prevent="abrir('fornecedor')">
                                Fornecedor/Prestador 
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" :class="aba == 'inventario' ? 'active' : ''" @click.prevent="abrir('inventario')">
                                Inventário 
                            </a>
                            <a class="dropdown-item" href="#" :class="aba == 'saldo-variacao' ? 'active' : ''" @click.prevent="abrir('saldo-variacao')">
                                Variação de Saldo 
                            </a>
                            <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="#" :class="aba == 'aquisicao' ? 'active' : ''" @click.prevent="abrir('aquisicao')">
                                    Aquisição 
                                </a>
                                <a class="dropdown-item" href="#" :class="aba == 'oc' ? 'active' : ''" @click.prevent="abrir('oc')">
                                    Ordens de Compra 
                                </a>
                                <a class="dropdown-item" href="#" :class="aba == 'alcadas' ? 'active' : ''" @click.prevent="abrir('alcadas')">
                                    Alçadas 
                                </a>
                            <div class="dropdown-divider" v-if="outras && outras.length"></div>
                            <template v-for="(outra, iox) in outras">
                                <a class="dropdown-item" href="#" :class="aba == 'mov-' + outra.id_estoque_tipo_movimentacao ? 'active' : ''" 
                                    @click.prevent="abrir('mov-' + outra.id_estoque_tipo_movimentacao, true)" :key="iox" v-if="true">
                                    {{ outra.search }} 
                                </a>
                            </template>
                            <div class="dropdown-divider"></div>

                            <a class="dropdown-item" href="#" :class="aba == 'checagem-consumo' ? 'active' : ''" @click.prevent="abrir('checagem-consumo')">
                                Checagem Consumo Paciente
                            </a>

                            <div class="dropdown-divider"></div>

                            <a class="dropdown-item" href="#" :class="aba == 'config' ? 'active' : ''" @click.prevent="abrir('config')">
                                Configurações 
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <klingo-pendencia />

        <visao-geral v-if="aba == 'visao2'" @abrirlanc="abrir_lancamentos" @abrirextrato="abrir_extrato"/>
        <cadastro-de-fornecedores :suprimentos="true" v-if="aba == 'fornecedor'" />
        <cadastro-estoque-grupo v-if="aba == 'grupo'"/>
        <cadastro-estoque-grupo-local v-if="aba == 'gestaoestoque'"/>
        <cadastro-estoque-local v-if="aba == 'local'"/>
        <cadastro-estoque-item v-if="aba == 'item'" />
        <inventario v-if="aba == 'inventario'" />
        <saldos v-if="aba == 'saldos'" />
        <movimentar-estoque v-if="aba == 'movimentacao'" />
        <estoque-atendimento v-if="aba == 'atendimento' || !aba" />
        <estoque-nota-fiscal v-if="aba == 'compra'" />
        <estoque-visao-geral v-if="aba == 'visao'" />
        <estoque-outras-movimentacoes v-if="aba && aba.substr(0,4) == 'mov-'" :id="aba.substr(4)" />
        <estoque-solicitacoes-realizadas v-if="aba == 'solicitacoes'" />
        <aquisicao v-if="aba == 'aquisicao'" :id="id" />
        <estoque-confirm-receb v-if="aba == 'recebimento'" />
        <estoque-ordem-compra v-if="aba == 'oc'" :id="id" />
        <alcadas-o-c v-if="aba == 'alcadas'" />
        <cadastro-estoque-kit v-if="aba == 'kit'" />
        <saldos-periodo v-if="aba == 'saldo-variacao'" />
        <confirmacao-de-uso-paciente v-if="aba == 'checagem-consumo'" :suprimentos="true" />


        <video id="beepElementId" src="https://api.klingo.app/message.ogg" style="display: none;" ></video>

        <!-- Configurações -->
        <div v-if="aba == 'config'">
            <div class="alert alert-info">
                Essas configurações são específicas para esse computador/navegador.
            </div>

            <div class="small text-muted mb-2" v-if="id_estoque_local">
                Notificações para o local #{{ id_estoque_local }}
            </div>

            <az-input
                type="checkbox-group"
                label="Emitir som ao receber notificação de nova solicitação"
                v-model="config.som_ao_notificar"
                @click="atualizar_config('som_ao_notificar')" />
        </div>
                
    </div>
</template>

<script>
import VisaoGeral from './VisaoGeral.vue';
import CadastroDeFornecedores from '../financeiro/CadastroDeFornecedores.vue';
import CadastroEstoqueGrupo from './CadastroEstoqueGrupo.vue';
import CadastroEstoqueGrupoLocal from './CadastroEstoqueGrupoLocal.vue';
import CadastroEstoqueLocal from './CadastroEstoqueLocal.vue';
import CadastroEstoqueItem from './CadastroEstoqueItem.vue';
import Inventario from './Inventario.vue';
import MovimentarEstoque from './MovimentarEstoque.vue';
import Saldos from './Saldos.vue';
import EstoqueAtendimento from './EstoqueAtendimento.vue';
import EstoqueNotaFiscal from './EstoqueNotaFiscal.vue';
import EstoqueOutrasMovimentacoes from './EstoqueOutrasMovimentacoes.vue';
import EstoqueVisaoGeral from './EstoqueVisaoGeral.vue';
import EstoqueSolicitacoesRealizadas from './EstoqueSolicitacoesRealizadas.vue';
import CadastroEstoqueKit from './CadastroEstoqueKit.vue';
import Aquisicao from './Aquisicao.vue';
import EstoqueConfirmReceb from './EstoqueConfirmReceb.vue';
import EstoqueOrdemCompra from './EstoqueOrdemCompra.vue';
import AlcadasOC from './AlcadasOC.vue';
import SaldosPeriodo from './SaldosPeriodo.vue';
import KlingoPendencia from '../../shared/KlingoPendencia.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";
import AzInput from '../../shared/forms/AzInput.vue';
import ConfirmacaoDeUsoPaciente from './ConfirmacaoDeUsoPaciente.vue';

export default {
  data() {
    return {
      dados: null,
      parms: null, 
      outras: [], 
      id_estoque_local: "", 
      config: { 
        som_ao_notificar: false, 
      } 
    };
  },

  components: { 
    VisaoGeral,
    CadastroDeFornecedores,
    CadastroEstoqueGrupo,  
    CadastroEstoqueLocal,
    CadastroEstoqueItem, 
    Inventario, 
    Saldos, 
    MovimentarEstoque,
    EstoqueAtendimento,
    EstoqueNotaFiscal, 
    EstoqueOutrasMovimentacoes, 
    EstoqueVisaoGeral, 
    Aquisicao, 
    EstoqueConfirmReceb, 
    CadastroEstoqueGrupoLocal, 
    EstoqueOrdemCompra, 
    AlcadasOC,
    CadastroEstoqueKit, 
    SaldosPeriodo, 
    KlingoPendencia, 
    AzInput, 
    EstoqueSolicitacoesRealizadas, 
    ConfirmacaoDeUsoPaciente,
  },

    props: ['aba', 'id'],

    methods: { 
        beep() {
            const el = document.getElementById("beepElementId");
            el.play();
        },

        atualizar_config (config) { 
            console.log(config, this.config.som_ao_notificar);
            switch (config) {
                case 'som_ao_notificar':
                    this.$util.setCookie('sup-notifc', !this.config.som_ao_notificar ? 'S' : 'N'); 
                    break;
            }
        },

        abrir(aba, movs = false) { 
        
            if ( aba != this.aba ) { 

                if ( movs ) { 
                    this.$router.push({ path: '/suprimentos/m' });    
                }

                this.$nextTick(() => { 
                    this.$router.push({ path: '/suprimentos/' + aba });
                });
            }

        },

        abrir_lancamentos (parms) { 
            this.parms = parms;
            this.aba = 'compra';

            this.$nextTick(() => { 
                this.parms = null;
            });
        },

        abrir_extrato (parms) { 
            this.parms = parms;
            this.aba = 'extrato';

            this.$nextTick(() => { 
                this.parms = null;
            });
        }
    },

    beforeDestroy() { 
        if ( this.canal ) { 
            unSubscribe(this.canal, "solicitacoes");
        }
        
    },

    mounted() { 
        this.config.som_ao_notificar = this.$util.getCookie('sup-notifc') == 'S' ? true : false; 

        this.$util.loadItem(this, { 
            service: "estoque_tipo_movimentacaos",
            func: "index",
            parms: { 
                outras: true, 
            }
        })
        .then(res => { 
            this.outras = res;
        });

        this.id_estoque_local = this.$util.getCookie('estoque-armazem');

        if ( this.id_estoque_local ) { 

            this.canal = this.$store.state.dominio + '-suprimentos-' + this.id_estoque_local;

            subscribe(this.canal, "solicitacoes", info => {
                if ( info && info.data ) { 

                    this.$toast.add({
                        severity: info.data.severity ? info.data.severity : 'info',
                        summary: info.data.summary ? info.data.summary : 'Atenção',
                        detail: info.data.detail,
                        life: ( info.data.life || info.data.life === 0 ) ? info.data.life : 8000, 
                    });

                    if ( this.config.som_ao_notificar ) { 
                        this.beep();
                    }

                }
            });

        }

    }
}
</script>